exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#cancelRound[data-v-16a73c76]{display:inline-block}.sortable_pick[data-v-16a73c76]{cursor:pointer}[data-v-16a73c76] .table-full .v-datatable.v-table>tbody{max-height:calc(100vh - 355px);min-height:calc(100vh - 355px)}[data-v-16a73c76] .v-table__overflow{max-height:47vh}", ""]);

// exports
